import ComparePanel from './comparePanel';

export default ComparePanel;